var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v(" 404 : Page not found ")]),_c('router-link',{attrs:{"to":"/countries"}},[_vm._v("Back to country selection")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }